import { useSelector } from 'react-redux';
import { SingleValueEventSelect as EventSelect } from 'ui/queryBuilder';
import {
  getStartNodeTriggerDataType,
  getStartNodeTriggerNodeClass,
} from 'modules/workflows/ducks/selectors';
import { ClientDataType } from 'modules/queryBuilder/types';
import { SelectOption } from 'modules/queryBuilder/contexts/visualComponents';
import { ConditionSingleValueSelectProps } from 'ui/queryBuilder/types';
import { USER } from 'constants/esDataTypes';
import { WORKFLOW_TRIGGERS } from 'modules/workflows/constants';
import { useShouldFilterFieldsAndProperties } from './useShouldFilterFieldsAndProperties';
import { useMemo } from 'react';

export function filterMappingsByTriggeringEvent({
  mappings,
  dataType,
}: {
  mappings: { value: string; title: string }[];
  dataType: string;
}) {
  return mappings.filter((mapping: { value: string; title: string }) =>
    mapping.value.startsWith(dataType),
  );
}

export const JourneyEventSelect = ({
  options,
  ...props
}: ConditionSingleValueSelectProps<ClientDataType>) => {
  const startNodeNodeClass = useSelector(getStartNodeTriggerNodeClass);
  const startNodeDataType = useSelector(getStartNodeTriggerDataType);

  const isAPICall = startNodeNodeClass === WORKFLOW_TRIGGERS.RECEIVED_API;

  const shouldFilterFieldsAndProperties = useShouldFilterFieldsAndProperties();
  const requiredDataType = isAPICall ? USER : startNodeDataType;

  const filteredOptions = useMemo(() => {
    return shouldFilterFieldsAndProperties
      ? filterMappingsByTriggeringEvent({
          mappings: options ?? [],
          dataType: requiredDataType as ClientDataType,
        })
      : options?.map((option: { value: string; title: string }) => ({
          value: option.value as ClientDataType,
          title: option.title,
        }));
  }, [
    options,
    requiredDataType,
    shouldFilterFieldsAndProperties,
  ]) as SelectOption<ClientDataType>[];

  return <EventSelect {...props} options={filteredOptions} />;
};
